import initiator from 'components/Overlay/Overlay.init'

export default function(){
    const target = 'be-component--overlay'
    const noMarkupInDOM = !document.querySelector('.' + target)

    if(noMarkupInDOM) {
        const markup = document.createElement('div')
        markup.classList.add(target)
        document.body.appendChild(markup)
        initiator()
    }
}